import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ErrorPage from "../../components/shared/ErrorPage";

class pageNotFound500 extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet title="Page not found" />
        <div className="errorPadContainer">
          <ErrorPage
            imageUrl="/assets/svg/logo500.svg"
            errorPageHeading="Uh oh…something’s wrong."
            errorCode="Error code: 500"
            errorPageDescription="Something went wrong and we’re working to get it fixed. Try
              refreshing the page, but if problems persist please send us an
              email at"
            email={true}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default {
  component: pageNotFound500
};
